import type { RouteConfig } from 'react-router-config'
import Blank from '@/layouts/Blank'
import { withAsync } from '@/components'
import addressBook from './addressBook'

const routes: RouteConfig[] = [
  {
    name: 'setting',
    path: '/setting',
    component: Blank,
    routes: [
      ...addressBook,
      {
        name: 'stores',
        path: '/stores/list',
        component: withAsync(() => import(/* webpackChunkName: "Store" */ '@/containers/Store')),
        exact: true,
        main: true,
        permissionCode: 'settings:store',
      },

      {
        name: 'account',
        path: '/account',
        component: withAsync(() => import('@/containers/ProviderSetting')),
        exact: true,
        main: true,
        permissionCode: 'settings:account',
      },
    ],
  },
]

export default routes
